import axios from 'axios'
import { store } from '@/store/store'
import config from '@/config'

const instance = () => {
  return axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })
}

const reportApi = {
  getPageReportSummary: (request) => {
    const { data } = request
    return instance().get(`/api/cms/export-pagereport-summary`, { params: data })
  }
}
export default reportApi



// WEBPACK FOOTER //
// ./src/api/report.js